import { Injectable } from '@angular/core';

import {
	AnalyticsAppInfo,
	AnalyticsService as CloudAnalyticsService,
	MixpanelAnalyticsProvider
} from '@shure/cloud/shared/utils/analytics';

/**
 * Simple utility to extract only public members from a class to allow it to be implemented as an interface.
 * Private members are automatically excluded when using keyof.
 */
type MakeInterface<TClass> = {
	[K in keyof TClass]: TClass[K];
};

/**
 * DON'T USE THIS SERVICE!!!
 * The shared AnalyticsService at @shure/cloud/shared/utils/analytics should be used for all analytics needs in the CDM app.
 * This service exists to support backwards compatibility with shared ShureCloud components, which rely on the Cloud analytics service.
 * It is simply a facade for the MixpanelAnalyticsProvider, which powers the shared AnalyticsService.
 *
 * @deprecated Use AnalyticsService from @shure/cloud/shared/utils/analytics instead.
 */
@Injectable()
export class CdmAnalyticsFacade implements MakeInterface<CloudAnalyticsService> {
	public mixpanel = this.mixpanelProvider.mixpanel;
	public oktaTokenClaims = this.mixpanelProvider.oktaTokenClaims;
	public readonly isMixpanelInitialized = this.mixpanelProvider.isMixpanelInitialized;
	public readonly isAnalyticsOptedIn = this.mixpanelProvider.isAnalyticsOptedIn;

	constructor(private readonly mixpanelProvider: MixpanelAnalyticsProvider) {}

	public setApplicationInfo(appInfo: AnalyticsAppInfo): void {
		this.mixpanelProvider.setApplicationInfo(appInfo);
	}

	public analyticDataCollector(event: string, data: object): void {
		this.submitToAnalyticsPlatform(event, data);
	}

	public submitToAnalyticsPlatform(event: string, data: object): void {
		this.mixpanelProvider.trackEvent({
			event,
			properties: data
		});
	}

	public initMixPanel(application: string, applicationVersion: string, mixpanelProjectToken?: string): void {
		this.mixpanelProvider.initMixPanel(application, applicationVersion, mixpanelProjectToken);
	}

	public sendSignInEvent(): void {
		this.mixpanelProvider.sendSignInEvent();
	}

	public sendOptInEvent(): void {
		this.mixpanelProvider.optIn();
	}

	public sendOptOutEvent(): void {
		this.mixpanelProvider.optOut();
	}
}
